import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton, MenuItem, Avatar } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useCreateHSEMutation } from "store/slices/apis/hseApiSlice";
import CalenderSVG from "assets/logo/Calendar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Collapse from "@mui/material/Collapse";
import { sectionOrder } from "./mapper";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const formData = {
    date: "",
    metrics: [
        {
            id: "m1",
            section: "Safe Manhours",
            description: "Safe manhour of Fourmativ team",
            value: ""
        },
        {
            id: "m2",
            section: "Safe Manhours",
            description:
                "Safe Manhours of Contractor (including employee, subcontractor workers & Supervisors, Securities and Driver)",
            value: ""
        },
        // {
        //     id: "m3",
        //     section: "Safe Manhours",
        //     description:
        //         "Total Man Hours",
        //     value: ""
        // },
        {
            id: "m36",
            section: "Incident",
            description:
                "Near Miss",
            value: ""
        },
        {
            id: "m37",
            section: "Incident",
            description:
                "Incidents with no lost time",
            value: ""
        },
        {
            id: "m38",
            section: "Incident",
            description:
                "First Aid Case (FAC)",
            value: ""
        },
        {
            id: "m39",
            section: "Incident",
            description:
                "Medical Treatment Case (MTC)",
            value: ""
        },
        {
            id: "m40",
            section: "Incident",
            description:
                "Lost-Time incidents(LTI)",
            value: ""
        },
        {
            id: "m41",
            section: "Incident",
            description:
                "No.of days Lost",
            value: ""
        },
        {
            id: "m42",
            section: "Incident",
            description:
                "Fire theft or other property damage",
            value: ""
        },
        {
            id: "m43",
            section: "Incident",
            description:
                "Environmental Incident",
            value: ""
        },
        {
            id: "m44",
            section: "Incident",
            description:
                "Frequency Rate (FR) : Total No.of accident x 1000000/Manhour worked",
            value: ""
        },
        {
            id: "m45",
            section: "Incident",
            description:
                "Severity Rate  (SR) : Total Mandays lost x 1000000/Manhours worked",
            value: ""
        },
        {
            id: "m46",
            section: "Incident",
            description:
                "Total No. of Fatality Case (FTC)",
            value: ""
        },
        {
            id: "m46",
            section: "Incident",
            description:
                "Restricted work cases",
            value: ""
        },
        {
            id: "m4",
            section: "Training",
            description: "No. of HS&E Training conducted",
            value: ""
        },
        {
            id: "m5",
            section: "Training",
            description:
                "Number of attendees present on the first day of induction training.",
            value: ""
        },
        {
            id: "m6",
            section: "Training",
            description:
                "No. of Tool Box Talk Training conducted",
            value: ""
        },
        {
            id: "m7",
            section: "Training",
            description:
                "No. of Environmental Training conducted",
            value: ""
        },
        {
            id: "m8",
            section: "Safety Meeting",
            description:
                "No. of HSE Committee Meeting conducted",
            value: ""
        },
        {
            id: "m9",
            section: "Reward & Recognition",
            description:
                "No. of Award and Recognition Conducted",
            value: ""
        },
        {
            id: "m10",
            section: "Reward & Recognition",
            description:
                "No.of Award is given",
            value: ""
        },
        {
            id: "m11",
            section: "Monitoring & Measurement",
            description:
                "No. of Emergency Mock drill conducted",
            value: ""
        },
        {
            id: "m12",
            section: "Monitoring & Measurement",
            description:
                "No. of Internal Audit by Third party or External Agency",
            value: ""
        },
        {
            id: "m13",
            section: "Monitoring & Measurement",
            description:
                "No. of Site HSE Inspection conducted by Site & HSE manager.",
            value: ""
        },
        {
            id: "m14",
            section: "Monitoring & Measurement",
            description:
                "No. of Inspection of lifting equipment,power tools etc.",
            value: ""
        },
        {
            id: "m15",
            section: "Monitoring & Measurement",
            description:
                "No. of Stop work notice issued",
            value: ""
        },
        {
            id: "m16",
            section: "Finding Tracker",
            description:
                "No. of HSE Finding",
            value: ""
        },
        {
            id: "m17",
            section: "Finding Tracker",
            description:
                "No. of closed HSE Finding.",
            value: ""
        },
        {
            id: "m18",
            section: "Finding Tracker",
            description:
                "No. of Open HSE Findings.",
            value: ""
        },
        {
            id: "m19",
            section: "Environment Reporting",
            description:
                "No. of Tree planted (Sapling)",
            value: ""
        },
        {
            id: "m20",
            section: "Environment Reporting",
            description:
                "Renewble Energy consumed for construction or ther activity if any.",
            value: ""
        },
        {
            id: "m21",
            section: "Environment Reporting",
            description:
                "Total water consumed for drinking purpose",
            value: ""
        },
        {
            id: "m22",
            section: "Environment Reporting",
            description:
                "Total water consumed for construction, drinking and other purpose (Kiloliters)",
            value: ""
        },
        {
            id: "m23",
            section: "Environment Reporting",
            description:
                "Total Diesel Consumption of DG",
            value: ""
        },
        {
            id: "m24",
            section: "Environment Reporting",
            description:
                "Total Diesel Consumption of site utlity vehicle",
            value: ""
        },
        {
            id: "m25",
            section: "Environment Reporting",
            description:
                "Total hazardous waste generated",
            value: ""
        },
        {
            id: "m26",
            section: "Environment Reporting",
            description:
                "Total hazardous waste Disposed",
            value: ""
        },
        {
            id: "m27",
            section: "Environment Reporting",
            description:
                "Total Oil waste generated",
            value: ""
        },
        {
            id: "m28",
            section: "Environment Reporting",
            description:
                "Total Oil waste Disposed",
            value: ""
        },
        {
            id: "m29",
            section: "Environment Reporting",
            description:
                "Total Non hazardous waste generated",
            value: ""
        },
        {
            id: "m30",
            section: "Environment Reporting",
            description:
                "Total Non hazardous waste Disposed",
            value: ""
        },
        {
            id: "m31",
            section: "Environment Reporting",
            description:
                "Total Plastic waste generated",
            value: ""
        },
        {
            id: "m32",
            section: "Environment Reporting",
            description:
                "Total Plastic waste Disposed",
            value: ""
        },
        {
            id: "m33",
            section: "Environment Reporting",
            description:
                "Total E-waste generated",
            value: ""
        },
        {
            id: "m34",
            section: "Environment Reporting",
            description:
                "Total E-waste Disposed",
            value: ""
        },
        {
            id: "m35",
            section: "Safety Resources",
            description:
                "No. of safety personal including safety manager; supervisor/steward & first aider in nos.(total in project)",
            value: ""
        },

    ]
};


const MetricRow = React.memo(
    ({ index, row, setFieldValue, rightLabelStyle, rightTextStyle, labelTextStyle }) => {

        const updateValue = (value) => {
            setFieldValue(`metrics[${index}].value`, value);
        };

        return (
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid size={{ xs: 12 }}>
                    <Typography sx={labelTextStyle}>Value</Typography>
                    <TextField
                        fullWidth
                        value={row.value || ""}
                        onChange={(e) => updateValue(e.target.value)}
                        placeholder="Enter Value"
                        InputProps={{
                            sx: {
                                height: "40px",
                                borderRadius: "8px",
                                backgroundColor: "#fff",

                                "& input::placeholder": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#0A0A0C",
                                    fontFamily: "Outfit, sans-serif",
                                    opacity: 1,
                                },
                                "& input": {
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "100%",
                                    letterSpacing: "0.16px",
                                    color: "#0A0A0C",
                                    fontFamily: "Outfit, sans-serif",
                                    "&:-webkit-autofill": {
                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                        WebkitTextFillColor: "#0A0A0C",
                                    },
                                    "&:-webkit-autofill:hover": {
                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                        WebkitTextFillColor: "#0A0A0C",
                                    },
                                    "&:-webkit-autofill:focus": {
                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                        WebkitTextFillColor: "#0A0A0C",
                                    },
                                },
                            },
                        }}
                    />

                </Grid>
            </Grid>
        );
    }
);

const ScrollToDateOnError = ({ errors, submitCount, dateRef }) => {
    React.useEffect(() => {
        if (submitCount > 0 && (errors.date || errors.metrics)) {
            dateRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            // const input = dateRef.current?.querySelector("input");
            // input?.focus();
        }
    }, [errors, submitCount, dateRef]);

    return null;
};

const AddHSE = (props) => {
    const { open, handleClose, actionContact } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [metricErrors, setMetricErrors] = React.useState(formData.metrics.map(() => null));
    const [openSections, setOpenSections] = useState({});
    const dateRef = React.useRef(null);

    const toggleSection = (section) => {
        setOpenSections((prev) => ({
            ...prev,
            [section]: !(prev[section] ?? true), // default open
        }));
    };

    const [createHSE, { isLoading }] = useCreateHSEMutation();

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        const filledMetrics = values.metrics.filter(
            (item) => item.value !== "" && item.value !== null
        );

        const filteredItems = filledMetrics.map((item) => ({
            section: item?.section,
            description: item?.description,
            date: moment.utc(values?.date, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
            value: item?.value,
        }));

        let reqBody = {
            projectId: projectId,
            items: filteredItems,
        };

        try {
            const response = await createHSE({ body: reqBody }).unwrap();
            openNotification("HSE created successfully", "success");
            resetForm();
            handleClose();
        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
        } finally {
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add HSE
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={formData}
                    enableReinitialize
                    onSubmit={handleSubmit}
                    validate={(values) => {
                        const errors = {};

                        if (!values.date) {
                            errors.date = "Date field is required";
                        }

                        const hasAtLeastOneValue = values.metrics.some(
                            (item) => item.value !== "" && item.value !== null
                        );

                        if (!hasAtLeastOneValue) {
                            errors.metrics = "At least one value is required";
                        }

                        return errors;
                    }}
                >
                    {({ values,
                        errors,
                        submitCount,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                        setTouched, }) => {

                        const metrics = values.metrics || [];

                        const groupedSections = metrics.reduce((acc, item, index) => {
                            if (!acc[item.section]) acc[item.section] = [];
                            acc[item.section].push({ ...item, index });
                            return acc;
                        }, {});

                        return (
                            <form onSubmit={handleSubmit}>

                                <ScrollToDateOnError errors={errors} submitCount={submitCount} dateRef={dateRef} />

                                <Grid size={{ xs: 12 }} sx={{ mb: 4 }} ref={dateRef}>
                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 2 }}>
                                        Select Date
                                    </Typography>
                                    <TextField
                                        type="date"
                                        name="date"
                                        value={values.date}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onClick={(e) => {
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                    {CalenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#fff",
                                                border: '1px solid',
                                                borderColor: 'hsl(0, 0%, 80%)',
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "5px",
                                            },
                                        }}
                                    />

                                    {(submitCount > 0) && errors?.date && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.date}
                                        </Typography>
                                    )}

                                    {(submitCount > 0) && errors.metrics && (
                                        <Typography
                                            sx={{
                                                color: "#d32f2f",
                                                fontSize: "12px",
                                                mt: 0.5,
                                            }}
                                        >
                                            {errors.metrics}
                                        </Typography>
                                    )}

                                </Grid>

                                {Object.keys(groupedSections).map((section) => {
                                    const isOpen = openSections[section] ?? true;

                                    return (
                                        <Box key={section} sx={{ mb: 3, mt: 1 }}>
                                            {/* Clickable Typography */}
                                            <Box
                                                onClick={() => toggleSection(section)}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "22px",
                                                        fontWeight: 600,
                                                        "&:hover": { color: "#1976d2" },
                                                    }}
                                                >
                                                    {section}
                                                </Typography>

                                                {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </Box>

                                            {/* Toggle content */}
                                            <Collapse in={isOpen}>
                                                {groupedSections[section].map((item, i) => (
                                                    <Box key={item.index} sx={{ mt: 3 }}>
                                                        <Typography sx={{ fontSize: "16px", color: "#5F5F5F" }}>
                                                            {i + 1}: {item.description}
                                                        </Typography>

                                                        <MetricRow
                                                            index={item.index}
                                                            row={values.metrics[item.index]}
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            metricErrors={metricErrors}
                                                            setMetricErrors={setMetricErrors}
                                                            rightLabelStyle={rightLabelStyle}
                                                            rightTextStyle={rightTextStyle}
                                                            labelTextStyle={labelTextStyle}
                                                        />
                                                    </Box>
                                                ))}
                                            </Collapse>
                                        </Box>
                                    );
                                })}


                                <Grid size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Button onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#F15744",
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "25px",
                                                fontWeight: 500,
                                                px: "20px",
                                                py: "15px",
                                            }}>
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            sx={{
                                                backgroundColor: "#00344C",
                                                borderRadius: "25px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: "20px",
                                                py: "15px",
                                            }}
                                        >
                                            Save
                                        </Button>
                                    </Box>
                                </Grid>
                            </form>
                        );
                    }}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddHSE;